<template>
  <section class="f-53">
    <div class="content_group">
      <img src="@/v2/auto/assets/image/53/bg.jpg" alt="" />
      <div class="font_group">
        <div class="title f-center-title">
          <div>AI 时代的</div>
          <div>专属控件库</div>
        </div>
        <div class="sub_title f-center-sub-title">
          <div>基于 AI 能力和交互方式定制，主流</div>
          <div>大模型均可完美适配</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BeautyAlive',
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {},
}
</script>

<style lang="less" scoped>
.f-53 {
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: #000000;
  padding-top: 100px;

  .content_group {
    width: 100%;
    position: relative;
  }
  img {
    width: 100%;
    height: auto;
  }
  .font_group {
    position: absolute;
    bottom: 35%;
    left: 20%;
  }

  .title {
    font-weight: bold;
    line-height: 1.5;
    background: radial-gradient(
      131.96% 70.14% at 50% 18.06%,
      #eadaff 0%,
      #ffffff 100%
    );
    color: transparent;
    background-clip: text;
  }
  .sub_title {
    margin-top: 12px;
    color: #ffffffcc;
    line-height: 1.6;
  }
}
</style>
